var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.dto.headerContractInfo
        ? _c("option-header-contract-info", {
            attrs: {
              id: "header-banner-contract-info",
              "current-contract-label":
                _vm.dto.headerContractInfo.currentContractLabel,
              "contract-selector-page-link-label":
                _vm.dto.headerContractInfo.contractSelectorPageLinkLabel,
              "contract-selector-page-link-url":
                _vm.dto.headerContractInfo.contractSelectorPageLinkUrl,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.dto.bannerTitle
        ? _c("option-banner", { attrs: { title: _vm.dto.bannerTitle } })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "option-detail-header" }, [
        _vm.dto.visual != null
          ? _c(
              "div",
              { staticClass: "w-100 option-detail-header__img" },
              [
                _c("ob1-picture", {
                  attrs: {
                    "css-classes": "img-fluid w-100",
                    visual: _vm.dto.visual,
                    "lazy-loading": false,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "option-detail-header-text-block d-flex flex-column mt-md-2 ms-0 ms-md-2 ms-lg-3",
          },
          [
            _c(
              "div",
              { staticClass: "option-detail-header-text text-white py-2" },
              [
                _c("h1", { staticClass: "mb-0" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.dto.shortLabel) +
                      "\n                "
                  ),
                ]),
                _vm._v(" "),
                _c("h4", { staticClass: "mb-0" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.dto.shortDescription) +
                      "\n                "
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "option-detail-header-text" },
              [
                _vm.dto.incentiveAuthenticate
                  ? _c("incentive-authenticate", {
                      attrs: {
                        title: _vm.dto.incentiveAuthenticate.question,
                        text: _vm.dto.incentiveAuthenticate.message,
                        "link-href": _vm.getAuthenticateLinkUrl,
                        "link-label": _vm.dto.incentiveAuthenticate.linkLabel,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container-fluid" },
        [
          _vm.dto.ineligibilityMessageAlerte
            ? _c("ob1-message-alerte", {
                staticClass: "mt-2 mt-md-3 mt-lg-4 mb-1 mb-md-2",
                attrs: {
                  "is-simple-alerte": false,
                  type: _vm.dto.ineligibilityMessageAlerte.alertType,
                  title: _vm.dto.ineligibilityMessageAlerte.title,
                  texts: _vm.dto.ineligibilityMessageAlerte.texts,
                  "with-link-from-dto": _vm.dto.ineligibilityMessageAlerte.link,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid" }, [
        _vm.dto.salesPitchDto
          ? _c(
              "div",
              { staticClass: "col-12 mt-1 mt-md-2 mb-1 mb-md-2 px-0" },
              [
                _c("sales-pitch", {
                  attrs: { "sales-pitch-dto": _vm.dto.salesPitchDto },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "margin-key-points container-fluid" },
        [
          _vm.dto.keyPoints.length > 0
            ? _c("key-points", { attrs: { "key-points": _vm.dto.keyPoints } })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container-fluid" },
        [
          _vm.dto.adviceDuty
            ? _c(
                "div",
                { staticClass: "col-12 mt-2 mt-md-3 mt-lg-4 px-0" },
                [
                  _c("advice-duty-bloc", {
                    attrs: { "advice-duty": _vm.dto.adviceDuty },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.dto.adviceDuty
            ? _c(
                "ob1-liens-haut-bas",
                {
                  staticClass: "col-12 mt-1 mt-lg-2 px-0",
                  attrs: {
                    "button-id": "simulator-link",
                    "collapsed-block-id": "simulator-block",
                    "button-label": _vm.dto.simulatorMessages.link,
                    "is-large": true,
                    "link-classes": "ps-1 ps-md-2 pe-2 bg-greige",
                  },
                  on: {
                    "ob1-liens-haut-bas-show-block": _vm.handleShowSimulator,
                  },
                },
                [
                  _c("simulator", {
                    staticClass: "mt-1 mt-lg-2",
                    attrs: {
                      variations: _vm.dto.variations,
                      "pre-selected-variation-id": _vm.dto.selectedVariationId,
                      messages: _vm.dto.simulatorMessages,
                      "option-label": _vm.dto.shortLabel,
                    },
                    on: { input: _vm.onInput },
                  }),
                ],
                1
              )
            : _c("simulator", {
                staticClass: "col-12 mt-2 mt-md-3 mt-lg-4 px-0",
                attrs: {
                  variations: _vm.dto.variations,
                  "pre-selected-variation-id": _vm.dto.selectedVariationId,
                  messages: _vm.dto.simulatorMessages,
                  "option-label": _vm.dto.shortLabel,
                },
                on: { input: _vm.onInput },
              }),
          _vm._v(" "),
          _vm.dto.pushZigZag.zigZagItems.length > 0
            ? _c("div", { staticClass: "px-0" }, [
                _c(
                  "div",
                  { staticClass: "mt-2 mt-md-3 mt-lg-4" },
                  [
                    _c("header-signature", {
                      attrs: { text: _vm.dto.pushZigZag.title },
                    }),
                    _vm._v(" "),
                    _c("push-zig-zag", {
                      attrs: { zigzag: _vm.dto.pushZigZag },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "px-0" }, [
            _vm.dto.faq
              ? _c(
                  "div",
                  [
                    _c("faq", {
                      attrs: {
                        title: _vm.dto.faq.title,
                        "question-list": _vm.dto.faq.questionList,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.dto.contractualDocuments.length > 0
            ? _c(
                "div",
                { staticClass: "px-0 mt-2 mt-md-3 mt-xl-4" },
                [
                  _c("contractual-documents", {
                    attrs: {
                      "contractual-documents": _vm.dto.contractualDocuments,
                      "web-view": _vm.dto.webView,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.dto.legalMention
        ? _c("div", { staticClass: "px-0 bg-gray2" }, [
            _c(
              "div",
              { staticClass: "container-fluid" },
              [
                _c("legal-mentions", {
                  attrs: { "legal-mention": _vm.dto.legalMention },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }